import {
	SHOP_MODIFIER_UPDATE_START,
	SHOP_MODIFIER_UPDATE_SUCCESS,
	SHOP_MODIFIER_UPDATE_ERROR
} from '../../../constants/index';
import { toastr } from 'react-redux-toastr';
import getAllModifierQuery from '../../../routes/shop/modifierGroups/getAllModifier.graphql';
import duplicateModifierMutation from './duplicateModifier.graphql';
import { getAllShopModifier } from './getAllShopModifier';

export default function duplicateModifier(id, currentPage, searchList) {
	return async (dispatch, getState, { client }) => {
		dispatch({
			type: SHOP_MODIFIER_UPDATE_START,
			payload: {
				updateLoading: true
			}
		});

		try {
			const { data: { duplicateModifier } } = await client.mutate({
				mutation: duplicateModifierMutation,
				variables: {
					id
				},
				refetchQueries: [{ query: getAllModifierQuery, variables: { currentPage, searchList } }],
				awaitRefetchQueries: true,
			});

			if (duplicateModifier && duplicateModifier.status === 200) {
				dispatch({
					type: SHOP_MODIFIER_UPDATE_SUCCESS,
					payload: {
						updateLoading: false
					}
				});
				toastr.success('Success!', `The Modifier has been duplicated successfully.`);
				dispatch(getAllShopModifier());
				return duplicateModifier.result && duplicateModifier.result.id;
			}

			dispatch({
				type: SHOP_MODIFIER_UPDATE_ERROR,
				payload: {
					updateLoading: false
				}
			});
			toastr.error('Error!', (duplicateModifier && duplicateModifier.errorMessage) || "Oops! Something went wrong. Please try again.");
			return null;

		} catch (err) {
			toastr.error('Error!', err.message || err);
			dispatch({
				type: SHOP_MODIFIER_UPDATE_ERROR,
				payload: {
					updateLoading: false
				}
			});
			return null;
		}
	}
};
